import { useDispatch } from "react-redux";
import { useState, useEffect, useRef } from "react";
import { updateOrderProductStatus, updateOrderStatus } from "../../api/kd";
import { NormalOrder } from "./orderType";
import { setLoading } from "../../reducers/userConfigSlice";

export const Order = ({ data, updateOrders }) => {
  const dispatch = useDispatch();
  const inFlight = useRef(false);
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const [orderData, updateOrderData] = useState(data);

  useEffect(() => {
    updateOrderData(data);
  }, [data]);

  const run = async (action) => {
    if (inFlight.current) return;
    inFlight.current = true; setBusy(true); setError(""); dispatch(setLoading(true));
    try { await action(); await updateOrders(); }
    catch (e) { setError(e.message || "No se pudo actualizar Cocina. Reintenta tras revisar el pedido."); }
    finally { inFlight.current = false; setBusy(false); dispatch(setLoading(false)); }
  };
  const updateOrderProduct = async (payload) => {
    const response = await updateOrderProductStatus(payload);
    if (response?.error !== false) throw Error(response?.message || "No se pudo actualizar la línea. Vuelve a intentarlo.");
  };

  const handleStateOrderData = async (orderProductId, targetStatus) => {
    if (orderData.status === "delivered") return;
    const productFound = orderData.products.find((product) => product.orderProductId === orderProductId);

    if (!productFound) return;

    const payload = {
      orderProductId: productFound.orderProductId,
      ...(targetStatus ? { status: targetStatus } : { prepared: productFound.status !== "prepared" }),
    };
    await run(() => updateOrderProduct(payload));
  };

  const handleAllStateOrderData = async (newState) => {
    if (orderData.status === "delivered") return;
    const statusOrder = newState === "preparedProducts" ? "inPreparation" : newState;

    const payload = { status: statusOrder };

    await run(async () => {
    if (newState === "preparedProducts") {
      // Update persisted lines separately; quantities do not identify a line.
      for (const product of orderData.products || []) {
        if (product.status !== "prepared") {
          await updateOrderProduct({ orderProductId: product.orderProductId, prepared: true });
        }
      }
    } else {
      const response = await updateOrderStatus(payload, data.orderId);
      if (response?.error !== false) throw Error(response?.message || "No se pudo actualizar el pedido.");
    }
    });
  };

  if (orderData.status === "delivered") {
    return <p role="status">Pedido entregado. No hay acciones de cocina pendientes.</p>;
  }

  return (
    <fieldset disabled={busy} aria-busy={busy} style={{border:0,padding:0,margin:0,minInlineSize:0}}>
    {error && <p role="alert">{error}</p>}
    <NormalOrder
      orderData={orderData}
      handleAllStateOrderData={handleAllStateOrderData}
      handleStateOrderData={handleStateOrderData}
    />
    </fieldset>
  );
};
